/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Arraste para redimensionar o painel',
  command_intelligence_close_aria: 'Fechar assistente',
  command_intelligence_send_aria: 'Enviar mensagem',
  command_intelligence_stop_aria: 'Parar resposta',
  command_intelligence_composer_input_aria: 'Mensagem para Command Intelligence',
  command_intelligence_drawer_more_options: 'Mais opções',
  command_intelligence_dock_position: 'Posição de acoplamento',
  command_intelligence_dock_left: 'Esquerda',
  command_intelligence_dock_right: 'Direita',
  command_intelligence_dock_top: 'Superior',
  command_intelligence_dock_bottom: 'Inferior',
  command_intelligence_panel_layout: 'Layout do painel',
  command_intelligence_panel_layout_overlap: 'Sobrepor conteúdo',
  command_intelligence_panel_layout_push: 'Empurrar conteúdo',
  command_intelligence_panel_auto_hide_overlap: 'Ocultar automaticamente ao clicar fora',
  command_intelligence_session_reset: 'Repor conversa',
  command_intelligence_try_one_of_these: 'Experimente uma destas',
  command_intelligence_attach_hint: 'Anexe itens de contexto para começar a fazer perguntas.',
  command_intelligence_attach_modal_title: 'Anexar contexto',
  command_intelligence_attach_modal_subtitle:
    'Escolha entre os itens nesta vista. Itens já anexados aparecem a cinzento.',
  command_intelligence_attach_modal_search_placeholder: 'Pesquisar…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# item disponível} other {# itens disponíveis}} · {selected} selecionados',
  command_intelligence_attach_modal_empty: 'Nada disponível para anexar',
  command_intelligence_attach_modal_no_results: 'Nenhum item corresponde à sua pesquisa',
  command_intelligence_context_bar_attached_section: 'Anexados ({count})',
  command_intelligence_context_bar_clear_attached: 'Limpar',
  command_intelligence_context_bar_add: 'Anexar contexto',
  command_intelligence_placeholder_ready: 'Faça uma pergunta…',
  command_intelligence_placeholder_attach: 'Anexe contexto para fazer uma pergunta…',
  command_intelligence_composer_submit_hint: 'Enter para enviar · Shift+Enter para nova linha',
  command_intelligence_composer_stop_hint: 'Parar · rascunho da próxima mensagem enquanto espera',
  command_intelligence_response_stopped: 'Resposta interrompida',
  command_intelligence_generation_in_progress: 'A trabalhar na sua pergunta',
  command_intelligence_generation_trace_title: 'Passos realizados',
  command_intelligence_generation_trace_toggle: 'Mostrar passos',
  command_intelligence_generation_trace_summary: '{completed} de {total} passos concluídos',
  command_intelligence_generation_trace_summary_generic: 'Passos de geração',
  command_intelligence_generation_tool_count: '{count, plural, one {# ferramenta} other {# ferramentas}}',
  command_intelligence_generation_turn_label: 'Turno {turn} de {total}',
  command_intelligence_generation_turn_completed: 'Turno {turn} de {total} concluído',
  command_intelligence_generation_turn_completed_elapsed: 'Turno {turn} de {total} concluído ({seconds}s decorridos)',
  command_intelligence_generation_turn_completed_with_tools: 'Turno {turn} de {total} concluído – usou {tools}',
  command_intelligence_generation_tools_used: 'Usou {tools}',
  command_intelligence_reasoning_thinking: 'A pensar…',
  command_intelligence_reasoning_thought_for_seconds: 'Pensou durante {seconds} segundos',
  command_intelligence_reasoning_waiting: 'A trabalhar na sua pergunta…',
  command_intelligence_attach_modal_done: 'Concluído',
  command_intelligence_attach_modal_attached_badge: 'anexado',
  command_intelligence_attach_modal_attach: 'Anexar',
  command_intelligence_attach_modal_attach_count: 'Anexar ({count})',
  command_intelligence_attach_modal_close_aria: 'Fechar seletor',
  command_intelligence_session_limit_context: 'Limite de contexto atingido. Reponha a conversa para continuar.',
  command_intelligence_session_limit_prompt: 'Limite de mensagens atingido. Reponha a conversa para continuar.',
  command_intelligence_suggested_followups: 'Seguimentos sugeridos',
  command_intelligence_credit_warning_line: '{pct}% dos créditos de IA mensais de {scope} utilizados',
  command_intelligence_tooltip_prompts: '{count} de {max} mensagens ({pct}%)',
  command_intelligence_tooltip_context: '{used} de {max} tokens de contexto ({pct}%)',
  command_intelligence_tooltip_context_idle: 'O uso de contexto aparece após a primeira resposta',
  command_intelligence_credits_loading: 'A carregar créditos…',
  command_intelligence_credits_unavailable: 'Créditos indisponíveis',
  command_intelligence_credits_tooltip: 'Créditos de IA mensais para {monthKey}',
  command_intelligence_credits_tooltip_short: 'Créditos de IA mensais',
  command_intelligence_credits_scope_profile: 'Perfil',
  command_intelligence_credits_scope_entity: 'Entidade',
  command_intelligence_credits_used_of_cap: '{used} de {cap} créditos',
  command_intelligence_credits_used_no_cap: '{used} créditos utilizados',
  command_intelligence_credits_monthly_title: 'Créditos de IA mensais',
  command_intelligence_compare_aria: 'Comparar agentes',
  command_intelligence_compare_tooltip: 'Executar a mesma pergunta em vários perfis de agente',
  command_intelligence_compare_cancelled: 'Comparação cancelada',
  command_intelligence_compare_branch_failed: 'Ramo de comparação falhou',
  command_intelligence_compare_title: 'Comparação de agentes',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} entrada / {outTok} saída · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Boa resposta',
  command_intelligence_feedback_bad_response: 'Má resposta',
  command_intelligence_feedback_dialog_title: 'Enviar feedback',
  command_intelligence_feedback_dialog_body:
    'Ajude-nos a melhorar enviando feedback sobre esta resposta. O seu feedback será enviado à nossa equipa de operações.',
  command_intelligence_feedback_response_label: 'Resposta',
  command_intelligence_feedback_input_label: 'O seu feedback (opcional)',
  command_intelligence_feedback_input_placeholder: 'O que estava errado ou pouco útil nesta resposta?',
  command_intelligence_feedback_submit: 'Enviar feedback',
  command_intelligence_feedback_submit_error: 'Falha ao enviar feedback. Tente novamente.',
  command_intelligence_feedback_question_understanding: 'O agente compreendeu o que queria?',
  command_intelligence_feedback_question_readability: 'A resposta foi fácil de ler e usar?',
  command_intelligence_feedback_section_understanding: 'Compreensão',
  command_intelligence_feedback_section_readability: 'Legibilidade',
  command_intelligence_feedback_choice_none: 'Nenhum',
  command_intelligence_feedback_choice_misunderstood_task: 'Tarefa mal compreendida',
  command_intelligence_feedback_choice_ignored_constraint: 'Restrição ignorada',
  command_intelligence_feedback_choice_wrong_scope: 'Âmbito incorreto',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Visualmente difícil de ler',
  command_intelligence_feedback_choice_wrote_too_much: 'Escreveu demasiado',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Explicação pouco fiável',
  command_intelligence_copy_aria: 'Copiar para a área de transferência',
  command_intelligence_error_missing_invoke_permission:
    'Não tem permissão para usar Command Intelligence com este agente. Peça ao administrador para conceder as permissões Intelligence necessárias (por exemplo, analyst).',
  command_intelligence_access_denied_title: 'Acesso necessário',
  command_intelligence_error_session_expired: 'A sua sessão expirou. Atualize a página e inicie sessão novamente.',
};
